'use client';

import { Navigate, useParams } from 'react-router-dom';

/** Legacy URL: redirects to machine detail (details + inventory on one page). */
const TomsVendingMachineInventoryPage: React.FC = () => {
  const { locationId, machineId } = useParams();
  return (
    <Navigate to={`/app/toms-vending/locations/${locationId}/machines/${machineId}`} replace />
  );
};

export default TomsVendingMachineInventoryPage;
